import Login from './components/paginas/Login';
import Inicio from './components/paginas/Inicio';
import Minutas from './components/paginas/Minutas';
import Usuarios from './components/paginas/Usuarios';
import Informes from './components/paginas/Informes';
import Sedes from './components/paginas/Sedes';
import Guia from './components/paginas/Guia';

export const APP_ROUTES = {
  login: '/',
  inicio: '/inicio',
  minutas: '/minutas',
  usuarios: '/usuarios',
  informes: '/informes',
  sedes: '/sedes',
  guia: '/guia',
};

export const routesConfig = [
  { path: APP_ROUTES.login, element: Login },
  { path: APP_ROUTES.inicio, element: Inicio },
  { path: APP_ROUTES.minutas, element: Minutas },
  { path: APP_ROUTES.usuarios, element: Usuarios },
  { path: APP_ROUTES.informes, element: Informes },
  { path: APP_ROUTES.sedes, element: Sedes },
  { path: APP_ROUTES.guia, element: Guia },
];
